export default "__VITE_PUBLIC_ASSET__6cefa22f__"